var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (cols, escapeAttr, undefined) {
// iterate cols || []
;(function(){
  var $$obj = cols || [];
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var col = $$obj[$index];

var columnStyle = col.width ? 'width: ' + col.width + ';' : null;
var attr = escapeAttr(col.attributes);
buf.push("<col" + (jade.attrs(jade.merge([{"style": jade.escape(jade.style(columnStyle)),"class": (jade_interp = [true], jade.joinClasses([col.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var col = $$obj[$index];

var columnStyle = col.width ? 'width: ' + col.width + ';' : null;
var attr = escapeAttr(col.attributes);
buf.push("<col" + (jade.attrs(jade.merge([{"style": jade.escape(jade.style(columnStyle)),"class": (jade_interp = [true], jade.joinClasses([col.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
    }

  }
}).call(this);
}.call(this,"cols" in locals_for_with?locals_for_with.cols:typeof cols!=="undefined"?cols:undefined,"escapeAttr" in locals_for_with?locals_for_with.escapeAttr:typeof escapeAttr!=="undefined"?escapeAttr:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/vnext/layout/column-group.jade
// module id = 101
// module chunks = 0